<div class="wrapper">
  <app-navbar></app-navbar>
  <app-header></app-header>
  <app-currency-dashboard></app-currency-dashboard>
  <app-trusted-platform></app-trusted-platform>
  <app-get-in-touch></app-get-in-touch>
  <app-start-trading></app-start-trading>
  <app-footer></app-footer>
</div>
